<ng-container *ngIf="show == 'y'">
    <ul class="sidebar navbar-nav">

        <!-- User Management -->
        <li class="nav-item-title" [ngClass]="(active == 'user-management')? 'active' : ''" style="text-align: left;">
            <a class="nav-link" href="#/user-management">
                <span>การจัดการผู้ใช้งาน</span>
            </a>
        </li>

        <!-- Satisfaction Management -->

        <li class="nav-item-title" [ngClass]="(active == 'satisfaction-management')? 'active' : ''" style="text-align: left;">
            <a class="nav-link" href="#/satisfaction-management">
                <span>การจัดการความพึงพอใจ</span>
            </a>
        </li>

        <!-- Page Management -->

        <li class="nav-item-title" [ngClass]="(active == 'page-management')? 'active' : ''" style="text-align: left;">
            <a class="nav-link" href="#/page-management">
                <span>การจัดการสิทธิ์การใช้งาน</span>
            </a>
        </li>
    </ul>
</ng-container>

<!-- <button *ngIf="show == 'n'" (click)="click('y')"></button> -->
<!-- <img class="hide" *ngIf="show == 'n'" (click)="click('y')" src="assets/icon/menu.png"> -->
